import React from 'react';
import '../styles/components/maintenanceBanner.css';

interface MaintenanceBannerProps {
  message: string;
  estimatedCompletion?: string | null;
}

export const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({ 
  message, 
  estimatedCompletion 
}) => {
  const formatEstimatedTime = (isoString: string) => {
    try {
      const date = new Date(isoString);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      });
    } catch {
      return isoString;
    }
  };

  return (
    <div className="maintenance-banner">
      <div className="maintenance-banner-content">
        <div className="maintenance-banner-icon">🔧</div>
        <div className="maintenance-banner-text">
          <div className="maintenance-banner-title">System Maintenance</div>
          <div className="maintenance-banner-message">
            {message || 'The system is currently undergoing maintenance. Please check back soon.'}
          </div>
          {estimatedCompletion && (
            <div className="maintenance-banner-eta">
              Estimated completion: {formatEstimatedTime(estimatedCompletion)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
